import { Link } from "react-router-dom";

const services = [
  {
    icon: "fas fa-bus",
    title: "Fixed Route Buses",
    description:
      "Our Trinidad Route and surrounding community connectors run daily on set schedules throughout the Trinidad area and neighboring communities – reliable transit you can count on.",
    href: "/airport-shuttle",
  },
  {
    icon: "fas fa-plane",
    title: "Airport Shuttle",
    description:
      "Scheduled service to and from regional airports. Check our timetable to connect with your flight without the parking hassle. No reservation needed for most routes.",
    href: "/airport-shuttle",
  },
  {
    icon: "fas fa-calendar-alt",
    title: "Seasonal Routes",
    description:
      "Expanded service during peak travel seasons and community events. Additional routes may serve recreation destinations and event venues across the Trinidad region.",
    href: "/airport-shuttle",
  },
  {
    icon: "fas fa-wheelchair",
    title: "Dial-a-Ride",
    description:
      "Curb-to-curb paratransit for riders who need extra assistance. Call (712) 206-1196 to schedule a pickup within our service area \u2014 available to qualifying individuals.",
  },
];

export default function ServicesSection() {
  return (
    <section className="w-full bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-20">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-10 md:mb-14">
          <div>
            <p className="text-xs font-label font-semibold tracking-[0.15em] text-primary-600 uppercase mb-3">
              How We Serve Trinidad
            </p>
            <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-foreground-900 leading-tight">
              Getting around{" "}
              <em className="text-primary-500 font-medium">made simple</em>
            </h2>
          </div>
          <p className="text-base text-foreground-600 leading-relaxed max-w-[420px] lg:text-right">
            Whether you're commuting to work, heading to an appointment, or catching a flight,
            Southern Transit has a service that fits your journey.
          </p>
        </div>

        {/* Cards Grid - 2x2 like original */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {services.map((service) =>
            service.href ? (
              <Link
                key={service.title}
                to={service.href}
                className="group flex gap-5 p-6 md:p-7 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-300 transition-all"
              >
                <div className="shrink-0">
                  <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-primary-50 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                    <span className="w-6 h-6 md:w-7 md:h-7 flex items-center justify-center text-primary-600 group-hover:text-background-50 transition-colors">
                      <i className={`${service.icon} text-lg md:text-xl`} />
                    </span>
                  </div>
                </div>
                <div>
                  <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                    {service.title}
                  </h3>
                  <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                    {service.description}
                  </p>
                </div>
              </Link>
            ) : (
              <div
                key={service.title}
                className="group flex gap-5 p-6 md:p-7 bg-background-50 rounded-xl border border-background-200/70"
              >
                <div className="shrink-0">
                  <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-primary-50 flex items-center justify-center">
                    <span className="w-6 h-6 md:w-7 md:h-7 flex items-center justify-center text-primary-600">
                      <i className={`${service.icon} text-lg md:text-xl`} />
                    </span>
                  </div>
                </div>
                <div>
                  <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 mb-2">
                    {service.title}
                  </h3>
                  <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                    {service.description}
                  </p>
                </div>
              </div>
            )
          )}
        </div>
      </div>
    </section>
  );
}